import Division from 'components/atoms/Division/Division';
import GridContainer from 'components/atoms/GridContainer/GridContainer';
import GridItem from 'components/atoms/GridItem/GridItem';
import CirclePercentage from 'components/molecules/Circle/CirclePercentage';
import CircleStat from 'components/molecules/Circle/CircleStat';
import React from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';

export default function CircleGroup(props) {
  const { item, ...rest } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <GridContainer
      direction={isMobile ? 'column' : 'row'}
      justify="center"
      alignItems="center"
    >
      <GridItem xs style={{ marginBottom: isMobile ? '30px' : 0 }}>
        <Division style={{ textAlign: 'center' }}>
          <CircleStat label={item.firstCircle.label} />
        </Division>
      </GridItem>
      <GridItem xs style={{ marginBottom: isMobile ? '30px' : 0 }}>
        <Division style={{ textAlign: 'center' }}>
          <CircleStat
            label={item.secondCircle.label}
            value={item.secondCircle.value}
          />
        </Division>
      </GridItem>
      <GridItem xs md={4}>
        <Division style={{ textAlign: 'center' }}>
          <CirclePercentage
            label={item.thirdCircle.label}
            value={item.thirdCircle.value}
          />
        </Division>
      </GridItem>
    </GridContainer>
  );
}

CircleGroup.propTypes = {};

CircleGroup.defaultProps = {};
